import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Switch, TextField } from "@mui/material";
import React from "react";
import useAuth from "../hooks/useAuth";
import { DataGrid } from "@mui/x-data-grid";
import { adminCloseUserOpenReports, adminEnableOrDisableProfile, adminEnableOrDisableUser, adminGetAllOpenReports } from "../../services/admin";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import SelectInput from "../common/SelectInput";
import { platformUsedOption } from "../constants/reports";
import moment from 'moment'

export const AdminReportPage = () => {

    
	const { getToken } = useAuth();
	const [reports, setReports] = React.useState([]);
    const currentIST = moment().format('YYYY-MM-DDTHH:mm')
	const pageSize = 10;
	const [currentPage, setCurrentPage] = React.useState(1);
	const [totalPages, setTotalPages] = React.useState(0);
    const [isModalOpen, setModalOpen] = React.useState(false);
    const [adminComment, setAdminComment] = React.useState("");
    const [selectedUser, setSelectedUser] = React.useState("");
    const [marriedTime, setMarriedTime] = React.useState(currentIST);
    const [platformUsed, setPlatformUsed] = React.useState('Other');
    const [otherPlatform, setOtherPlatform] = React.useState('');
    const [partnerName, setPartnerName] = React.useState('');
    const [userFeedback, setUserFeedback] = React.useState('');
    const [platformRole, setPlatformRole] = React.useState('');
    const [isMarried, setIsMarried] = React.useState(false);


    const columns = [
        {
            field: 'reportedProfileName',
            headerName: 'Reported User Name',
            width: 150,
			renderCell: (entity) => {
				return (
					<Link
						to={`/administratorpath/viewprofile/${entity.row.reportedProfileID}`}
						className='sign-up sign-up-button'
					>
						{entity.row.reportedProfileName}
					</Link>
				);
			},
        },
        {
            field: 'reportedProfileContactNumber',
            headerName: 'Reported User Contact Number',
            width: 200,
        },
        {
            field: 'reportedProfileContactEmail',
            headerName: 'Reported User Contact Email',
            width: 200,
        },
        {
            field: 'reporterName',
            headerName: 'Reporter User Name',
            width: 150,
			renderCell: (entity) => {
				return (
					<Link
						to={`/administratorpath/viewprofile/${entity.row.reporterID}`}
						className='sign-up sign-up-button'
					>
						{entity.row.reporterName}
					</Link>
				);
			},
        },
        {
            field: 'reporterContactNumber',
            headerName: 'Reporter User Contact Number',
            width: 200,
        },
        {
            field: 'reporterContactEmail',
            headerName: 'Reporter User Contact Email',
            width: 200,
        },
        {
            field: 'reporterComment',
            headerName: 'User Comment',
            width: 300,
        },
        {
            field: 'userComment',
            headerName: 'User Comment',
            width: 200,
            renderCell: (entity) => {
				return (
					<Button
                        fullWidth
                        variant='contained'
                        sx={{ m: 2 }}
                        onClick={() => {
                            setModalOpen(true)
                            setSelectedUser(entity.row.reportedProfileID)
                        }}
                    >
                        Action Report
                    </Button>
				);
			},
        },
        
    ];

    const getAllReports = () => {
        let auth = getToken();
        if (auth) {
            adminGetAllOpenReports(
                auth.token,
                currentPage === 0 ? 1 : currentPage,
                pageSize
            ).then((response) => {
                if (response.data.errors) {
                    toast.error(
                          'Issue in fetching reports please try refreshing',
                        { timeOut: 1000 }
                    );
                    console.error('Error in fetching reports', response.data.errors);
                } else {
                    let allReports = response.data.adminGetAllReports;
                    setReports(allReports.reports)
                    setTotalPages(allReports.totalPages)
                }
            }).catch((error) => {
                toast.error(
                    'There was an issue with fetching the reports. Please try again.',
                    { timeOut: 1000 }
                );
                console.error('Error in getAllReports:', error);
            });
		}
    }

    // Function to close modal
    const handleClose = () => {
        setModalOpen(false);
        // Reset the admin comment or any other modal-related state
        setAdminComment("");
        setSelectedUser("");
        setMarriedTime(moment().format('YYYY-MM-DDTHH:mm'));
        setPlatformUsed('Other');
        setOtherPlatform("");
        setPartnerName("");
        setUserFeedback("");
        setPlatformRole("");
    };

    const disableUser = () => {
        let auth = getToken();
        if (auth) {
            adminEnableOrDisableUser(auth.token, selectedUser, false).then(
                (response) => {
                    if (response.data.errors) {
                        toast.error(
                            'There was an issue with disabing the user. Please try from admin view.',
                            { timeOut: 1000 }
                        );
                        console.error('Error in enabling or disabling user', response.data.errors);
                    } else {
                        toast.info( 'User Disabled',{ timeOut: 1000 });
                    }
                }
            ).catch((error) => {
                toast.error(
                    'There was an issue with disabing the user. Please try from admin view.',
                    { timeOut: 1000 }
                );
                console.error('Error in disable user:', error);
            });
        }
	};

	const disableProfile = () => {
		let auth = getToken();
		if (auth) {
            adminEnableOrDisableProfile(
                auth.token,
                selectedUser,
                false
            ).then((response) => {
                if (response.data.errors) {
                    toast.error(
                        'There was an issueis disabling profile. Please try from admin view.',
                        { timeOut: 1000 }
                    );
                    console.error('Error in disabling profile', response.data.errors);
                } else {
                    toast.info('Profile Disabled', { timeOut: 1000 } );
                }
            }).catch((error) => {
                 toast.error(
                    'There was an issueis disabling profile. Please try from admin view.',
                    { timeOut: 1000 }
                );
                console.error('Error in disableProfile:', error);
            });
		}
	};

     const handleDisableProfile = async () => {
        await disableProfile();
        await disableUser();
        handleDismissReport();
    };

    const handleDismissReport = () => {
        const auth = getToken();
        const platform = platformUsed === "Other" ? otherPlatform : platformUsed
        const isoMarriedTime = platform !== "" ? moment(marriedTime).toISOString(): moment.utc('0001-01-01 00:00:00').toISOString();
        if (auth) {
            var adminReport = {
                adminComment: adminComment,
                partnerName: partnerName,
                platformUsed: platform,
                platformRole: platformRole,
                marriedTime: isoMarriedTime,
                userFeedback: userFeedback
            }
            adminCloseUserOpenReports(
                auth.token,
                selectedUser,
                adminReport
            ).then((response) => {
                if (response.errors) {
                    toast.error(
                        'There was an issue with dismissing the report. Please try again.',
                        { timeOut: 1000 }
                    );
                    console.error('Error dismissing report:', response.errors);
                } else {
                    // If the mutation was successful, you may want to update your state or trigger a re-fetch of the reports
                    toast.success(
                        'Report dismissed successfully.',
                        { timeOut: 1000 }
                    );
                    getAllReports(); // Re-fetch reports if needed, or use another method to update your state
                }
            }).catch((error) => {
                 toast.error(
                    'There was an issue with dismissing the report. Please try again.',
                    { timeOut: 1000 }
                );
                console.error('Error in handleDismissReport:', error);
            });
        } else {
            alert('Authentication failed. Please log in again.');
        }
        handleClose()
    };

    React.useEffect(() => {
		getAllReports();
	}, [currentPage]);

    return <>
    
    <ToastContainer />
    <div className='col p-1 home-profiles' style={{ height: '600px', overflow: 'scroll', padding: 20 }}>
        <Dialog open={isModalOpen} onClose={handleClose}>
            <DialogTitle>Report Actions</DialogTitle>
            <DialogContent>
                <FormControlLabel
                    control={
                        <Switch
                            checked={isMarried}
                            onChange={(e) => setIsMarried(e.target.checked)}
                            name="isMarried"
                            color="primary"
                        />
                    }
                    label="Is User Married"
                />
                <TextField
                    autoFocus
                    margin="dense"
                    id="adminComment"
                    label="Admin Comment"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={adminComment}
                    onChange={(e) => setAdminComment(e.target.value)}
                    required
                />
                { isMarried &&
                    <>
                        <TextField
                            autoFocus
                            margin="normal"
                            id="marriedTime"
                            label="Married Time"
                            type="datetime-local"
                            fullWidth
                            value={marriedTime}
                            onChange={(e) => setMarriedTime(e.target.value)}
                            variant="outlined"
                            style={{marginBottom: 20}}
                            required
                        />
                        <SelectInput
                            name='platformUsed'
                            label='Platform Used'
                            value={platformUsed}
                            handleChange={(e) => setPlatformUsed(e.target.value)}
                            fullWidth
                            variant='standard'
                            placeholder='Select platform used'
                            options={platformUsedOption}                            
                        />
                        {platformUsed === 'Other' && (
                            <TextField
                                margin="normal"
                                id="otherPlatform"
                                label="Other Platform"
                                fullWidth
                                value={otherPlatform}
                                onChange={(e) => setOtherPlatform(e.target.value)}
                                variant="outlined"
                                required
                            />
                        )}
                        <TextField
                            margin="normal"
                            id="partnerName"
                            label="Partner Name"
                            fullWidth
                            value={partnerName}
                            onChange={(e) => setPartnerName(e.target.value)}
                            variant="outlined"
                        />
                        <TextField
                            margin="normal"
                            id="userFeedback"
                            label="User Feedback"
                            fullWidth
                            multiline
                            rows={4}
                            value={userFeedback}
                            onChange={(e) => setUserFeedback(e.target.value)}
                            variant="outlined"
                            required
                        />
                        <TextField
                            margin="normal"
                            id="platformRole"
                            label="Platform Role"
                            fullWidth
                            value={platformRole}
                            onChange={(e) => setPlatformRole(e.target.value)}
                            variant="outlined"
                        />
                    </>
                }
                
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', padding: '8px 24px' }}> {/* Center the buttons and add padding */}
                {
                    isMarried ? 
                    <Button
                        onClick={handleDisableProfile}
                        variant="contained"
                        sx={{ textTransform: 'none' }} // Remove text capitalization, add margin
                    >
                        Disable Profile
                    </Button> :
                    <Button
                        onClick={handleDismissReport}
                        variant="outlined"
                        sx={{ textTransform: 'none' }} // Remove text capitalization
                    >
                        Dismiss Open Reports
                    </Button>
                }
            </DialogActions>
        </Dialog>
        <DataGrid
            style={{margin: 20}}
            rows={reports.map((report, index) => {
                return {
                    id: index,
                    ...report
                }
            })}
            columns={columns}
            pageSize={pageSize}
            page={currentPage - 1}
            paginationMode='server'
            onPageChange={(newpage) =>
                setCurrentPage(newpage + 1)
            }
            rowCount={totalPages * pageSize}
        />
    </div>
    </>
}